var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 265"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 104",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4500_134399",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 23,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.643 32.7104H24.5446L23.2435 25.5143C23.1638 25.0895 22.9514 24.9036 22.8452 24.9036C22.7389 24.877 22.5796 25.0629 22.5 25.3019L20.2694 31.2234C19.9242 32.1262 19.048 32.737 18.092 32.737C17.0033 32.737 16.0474 31.9935 15.8084 30.9048L14.9587 27.081C14.879 26.7092 14.6931 26.5234 14.5603 26.5234C14.4541 26.5234 14.2417 26.6827 14.162 27.1341L13.1264 32.7104H7.92188L12.3829 8.57294C12.6485 7.16559 13.631 6.50174 14.5072 6.47518C15.357 6.47518 16.366 7.05937 16.6847 8.44017L17.9327 14.0165L20.8271 6.42208C21.1988 5.41303 22.0751 4.80229 23.0045 4.88195C24.0135 4.98817 24.7836 5.78478 24.996 6.97971L29.643 32.7104Z",
    fill: "#0099FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4500_134399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 19.9574,
    cy: 20.514,
    r: 16.9086,
    fill: "#FFA300"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 13.1776,
    cy: 13.1776,
    r: 13.1776,
    transform: "matrix(1 0 0 -1 15.0957 37.3223)",
    fill: "url(#paint0_linear_4500_134399)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 12.5425,
    cy: 12.5425,
    r: 12.5425,
    transform: "matrix(1 0 0 -1 -1.5957 40.8789)",
    fill: "url(#paint1_linear_4500_134399)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4500_134399",
    x1: 9.41164,
    y1: 13.5512,
    x2: -2.83541,
    y2: 10.1921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A49BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A49BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4500_134399",
    x1: 16.726,
    y1: 19.2064,
    x2: 9.51771,
    y2: 33.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmall);
export default __webpack_public_path__ + "static/media/icon-small.4ab75e7cb37288248ddc83ac92bc7b9f.svg";
export { ForwardRef as ReactComponent };